import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {MeasurementStub} from '../entities/MeasurementStub';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {MeasurementDetailsSummary} from '../entities/MeasurementDetailsSummary';
import {map} from 'rxjs/operators';
import { AnamnesenStub } from '../entities/AnamnesenStub';

@Injectable({
  providedIn: 'root'
})
export class AnamnesenService {

  constructor(private httpClient: HttpClient) { }

  /**
   * a non cached list of AnamnesenStub for Patient
   */
  public getList(patientId: number): Observable<Array<AnamnesenStub>> {
      return this.httpClient.get('/api/patients/' + patientId + '/anamnesen')
          .map((resp: Array<any>) => {
            const mlist: Array<AnamnesenStub> = [];
            resp.forEach(item => mlist.push(AnamnesenStub.parse(item))); 
            return mlist;
          });
  }

    public getCsv(patientId: string, id: string): Observable<ArrayBuffer> {
        const options: {
            headers?: HttpHeaders;
            observe?: 'body';
            params?: HttpParams;
            reportProgress?: boolean;
            responseType: 'arraybuffer';
            withCredentials?: boolean;
        } = {
            responseType: 'arraybuffer'
        };
        return this.httpClient.get('/api/patients/'+ patientId +'/anamnesen/' + id +'/csv', options)
            .pipe(
                map((file: ArrayBuffer) => {
                    return file;
                })
            );
    }
}
